import LetterbooksFilterWarning from "./LetterbooksFilterWarning/LetterbooksFilterWarning";
import LetterbooksCollection from "./LetterbooksCollection/LetterbooksCollection";
import LetterbooksPagination from "./LetterbooksPagination/LetterbooksPagination";
import { LetterbookSettingType } from "features/Letterbooks/types";

interface LetterbookOptions {
  settings: LetterbookSettingType;
}

export default function LetterbooksBooks({
  settings,
}: LetterbookOptions) {
  return (
    <>
      <LetterbooksFilterWarning />
      <LetterbooksCollection settings={settings} />
      <LetterbooksPagination settings={settings} />
    </>
  );
}
